// extracted by mini-css-extract-plugin
export default {"wrapper":"NoPermission_wrapper__34xTs","bold":"NoPermission_bold__nZE4C"};